import { MapPin, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ESTADOS, municipiosOf } from "@/lib/venezuelaLocations";

// Cascading Estado -> Municipio dropdowns with an optional geolocation detect button.
export function LocationSelect({ state, municipality, onChange, onDetect, detecting, prefix = "loc" }) {
  const { t } = useTranslation();
  const setState = (e) => onChange({ state: e.target.value, municipality: "" });
  const setMuni = (e) => onChange({ state, municipality: e.target.value });

  return (
    <div className="flex flex-col gap-2">
      <div className="grid grid-cols-2 gap-2">
        <select data-testid={`${prefix}-state`} className="native-select" value={state} onChange={setState}>
          <option value="">{t("common.state")}</option>
          {ESTADOS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select data-testid={`${prefix}-municipality`} className="native-select" value={municipality}
          onChange={setMuni}>
          <option value="">{t("common.municipality")}</option>
          {municipiosOf(state).map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
      </div>
      {onDetect && (
        <button type="button" onClick={onDetect} data-testid={`${prefix}-detect`}
          className="self-start min-h-[40px] px-3 rounded-sm border border-neutral-300 bg-white hover:bg-neutral-50 flex items-center gap-1 text-sm">
          {detecting ? <Loader2 className="w-4 h-4 animate-spin" /> : <MapPin className="w-4 h-4" />}
          {t("common.detectLocation")}
        </button>
      )}
    </div>
  );
}
